/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/en-gb";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";
import {
  DatePicker,
  Skeleton,
  Button,
  Select,
  Divider,
  Popover,
  Tag,
  Tooltip,
} from "antd";
import {
  MoreOutlined,
  CarryOutOutlined,
  PauseOutlined,
  ReloadOutlined,
  FieldTimeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  LoadingOutlined,
  // PlaySquareOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import async from "async";
import { keys } from "lodash";
import { isMobile, isSafari } from "react-device-detect";
import {
  getReadySendReports,
  getData,
  saveData,
  sendS3UrlGrouped,
  moveFilesToHistory,
  moveFiles,
  deleteFiles,
  runQCApiPost,
  updateTestResult,
  updateReportsSendStatus,
  approveRejectSampleQC,
} from "../../../../actions/sendReports";
import { automatedServerRoute } from "../../../../utils/Constant";
import { fetchTestCategory } from "../../../../actions/chemistry";
import { postBatchReports } from "../../../../actions/batchReports";
import Loading from "../../../../assets/images/loading.gif";
import FailedReportsEmailModal from "./FailedReportsEmailModal";
import FailedToGetFileModal from "./FailedToGetFileModal";
import SearchSendReports from "./SearchSendReports";
import SendReportsPreview from "./SendReportsPreview";
import SendReportsConfirmModal from "./SendReportsConfirmModal";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import UnderMaintenance from "./UnderMaintenance";
import { SendLog } from "../util/Logger";
import {
  downloadFileFromS3,
  getFileFromS3,
  getUser,
  pause,
  getAppVersion,
  uploadFileToS3,
  getPresignedURL,
  formatAntdDateRange,
} from "../../../../utils/helpers";
// import multiDownload from "multi-download";
import { s3ESVPrivate, s3AutomationPrivate } from "../../../../utils/aws";
import { getUserList } from "../../../../actions/sendReports";
import StatusTag from "../../../Common/components/StatusTag";
import "../sendreports.css";

const DateFormat = "MM/DD/YYYY";

export const AI_QC_OPTIONS = [
  { value: "", label: "All" },
  { value: 0, label: "Not QC" },
  { value: 1, label: "Pass" },
  { value: 2, label: "Fail" },
];

export const SOFTWARE_QC_OPTIONS = [
  { value: "", label: "All" },
  { value: 0, label: "Not QCed" },
  { value: 1, label: "QC Passed" },
  { value: 2, label: "QC Failed" },
  { value: 3, label: "No History" },
];

export const MANUAL_QC_OPTIONS = [
  { value: "", label: "All" },
  { value: 0, label: "Not QC" },
  { value: 1, label: "Pass" },
  { value: 2, label: "Hold" },
];

export const ML_SOFTWARE_QC_OPTIONS = [
  { value: "", label: "All" },
  { value: 0, label: "Not QCed" },
  { value: 1, label: "QC Passed" },
  { value: 2, label: "QC Failed" },
  { value: 3, label: "No History" },
];

/**
 * Return the date range for the history tab
 * @param {*} selectedDateObj antd date object
 * @returns {object} {startDate, endDate}
 */
const getHistoryDates = (selectedDateObj = null) => {
  const user = getUser();
  const noPermissionDates = { startDate: dayjs().add(-1, "M"), endDate: dayjs() };
  if (!user.permissionMap) {
    return noPermissionDates;
  }
  // Return current month if user has permission
  if (user.permissionMap.view_sendreports_history_date) {
    const startDate = selectedDateObj || dayjs(moment().startOf("month").format(DateFormat), DateFormat);
    const endDate = selectedDateObj ? dayjs(moment(selectedDateObj.$d).endOf("month").format(DateFormat), DateFormat) : dayjs();
    return { startDate, endDate };
  }

  // Return last two weeks if user doesn't have permission
  return noPermissionDates;
};

export default class SendReportsAuto extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    this.state = {
      filesReady: [],
      selectAll: false,
      loading: false,
      skeletonLoading: true,
      qcLoading: false,
      fileFailedToGet: [],
      historyDate: getHistoryDates().startDate,
      groupedCompanyNamesAndDate: {},
      emailSent: [],
      emailFailed: [],
      searchValue: "",
      showEmailFailed: false,
      showFailedToGet: false,
      order: "DSC",
      fileNameSort: false,
      counter: 0,
      previewFile: "",
      headerHeight: 90, // Default header height
      showPreview: false,
      sendingReports: false,
      selectedReports: {
        qcFailed: [],
        qcNotRun: [],
        qcUnknown: [],
      },
      woStatus: new Map(),
      badWoList: [],
      datePickerRef: React.createRef(),
      showConfirmation: false,
      confirmationTitle: "",
      confirmationBodyComponent: null,
      fromRemoveClick: false,
      currWoId: "",
      currPreviewIdx: -1,
      enableEdit: false,
      apiController: null,
      moveCategory: "",
      selectedFilter: -1,
      actionsList: [
        { value: -1, label: "All" },
        { value: 0, label: "Pending" },
        { value: 1, label: "Approved" },
        { value: 2, label: "Hold" },
        { value: 3, label: "Retesting" },
      ],
      markCategory: null,
      runQcType: null,
      sendAutoConfirm: false,
      selectedQc: "",
      selectedAiQc: "",
      selectedMLSoftQc: "",
      user: getUser(),
      testCategories: [{ value: "", label: "All Categories" }],
      testCategoriesOptions: [{ value: "", label: "All Categories" }],
      createByUserOptions: [{ value: "", label: "All" }],
      approvedByUserOptions: [{ value: "", label: "All" }],
      selectedCreatedBy: "",
      selectedApprovedBy: "",
      selectedSentBy: "",
      fileLoadingIndex: null,
      selectedCategory: "",
    };
  }

  componentDidMount = () => {
    const { server, tab } = this.props;
    const { historyDate } = this.state;
    
    // Set up ResizeObserver to track header height changes
    this.setupHeaderHeightObserver();
    
    // Set initial CSS custom property value. This is used in the 'sendReportsTableHeadingOriginal' class
    document.documentElement.style.setProperty('--header-height', '90px');
    
    // Check if webpage was opened with the server route
    if (server) {
      const date = "";
      const input = "";
      const category = "available";

      this.getFilesReady(date, input, "DSC", category);
    } else {
      this.fetchTestCategories();
      const date = tab === "history" ? historyDate : "";
      const category = tab;
      const input = "";

      this.getFilesReady(date, input, "DSC", category);
      // fetch user list for dropdown options
      this.fetchUserList();
    }
  };

  setupHeaderHeightObserver = () => {
    if (this.headerRef.current && window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const newHeight = entry.contentRect.height;
          const adjustedHeight = newHeight + 18; // Add 18px buffer
          this.setState({ headerHeight: adjustedHeight });
          
          // Update CSS custom property for dynamic positioning
          document.documentElement.style.setProperty('--header-height', `${adjustedHeight}px`);
        }
      });
      
      this.resizeObserver.observe(this.headerRef.current);
    }
  };

  componentWillUnmount = () => {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  };

  fetchTestCategories = async () => {
    const { success, results, message } = await fetchTestCategory();
    if (success) {
      const newCategoryList = [{ value: "", label: "All Categories" }];
      const testCategoriesOptions = [{ value: "", label: "All Categories" }];
      results.forEach((item) => {
        const { test_category_name, id } = item;
        newCategoryList.push({ value: test_category_name, label: test_category_name });
        testCategoriesOptions.push({ value: id, label: test_category_name });
      });
      this.setState({ testCategories: newCategoryList, testCategoriesOptions });
    } else {
      toast.error(message);
    }
  };

  /**
   * Use the AbortController to cancel the last producttemplates/ call if the last call was still in progress.
   * @param {*} controller
   */
  abortPrevApiCall = (controller) => {
    const { apiController } = this.state;
    if (apiController) {
      apiController.abort();
    }
    this.setState({ apiController: controller });
  };

  getFilesReady = async (dateInput, searchInput, order, category) => {
    const {
      loading, selectedFilter, selectedQc, selectedAiQc, selectedCreatedBy, selectedApprovedBy, selectedSentBy, selectedMLSoftQc, selectedCategory,
    } = this.state;
    let date = "";
    if (category === "history") {
      date = formatAntdDateRange([dateInput, getHistoryDates(dateInput).endDate]);
    }
    const input = searchInput;
    const files = [];
    const { server } = this.props;
    const woStatus = new Map();
    if (date === "Invalid date" || category !== "history") {
      date = "";
    }

    this.setState({ skeletonLoading: !loading }, async () => {
      const controller = new AbortController();
      this.abortPrevApiCall(controller);
      const params = {
        date_range: date,
        search: input,
        order,
        category,
        test_category_id: selectedCategory,
        filter: selectedFilter === -1 ? "" : selectedFilter,
        qc_status: selectedQc,
        ml_qc_status: selectedAiQc,
        ml_soft_qc_result: selectedMLSoftQc,
        created_by: selectedCreatedBy,
        approved_by: selectedApprovedBy,
        sent_by: selectedSentBy,
      };
      const response = await getReadySendReports(params, controller.signal);
      if (response && response.success && response.list.length > 0) {
        response.list.forEach((element) => {
          if (woStatus.get(element.wo_id) === undefined) {
            woStatus.set(element.wo_id, { wo_id: element.wo_id, reportsLeft: 0, totalReports: 0 });
          }
          woStatus.get(element.wo_id).reportsLeft++;
          woStatus.get(element.wo_id).totalReports++;
          const pathIdx = element.path.split("/").length - 1;
          if (server) {
            if (element.approve_status === 1) { // Send only approved reports
              const time_stamp = moment(element.time_stamp).format(
                "MM/DD/YYYY, h:mm:ss a",
              );
              const file = {
                path: element.path.split("/")[pathIdx],
                wo: element.wo_id,
                customer: element.customer_id,
                checked: false,
                receivedDate: element.received_date,
                time: time_stamp === "Invalid date" ? "-" : time_stamp,
                created_by: element.created_by,
                type: element.belongs,
                reportID: element.report_id,
                qc: element.ml_soft_qc,
                sample_info: element.sample_info,
                s3Path: element.path,
                approve_status: Number(element.approve_status),
                approved_by: element.approved_by,
                approved_at: element.approved_at ? moment(element.approved_at).format("MM/DD/YYYY, h:mm:ss a") : "",
                sent_by: element.sent_by,
                sent_at: element.sent_at ? moment(element.sent_at).format("MM/DD/YYYY, h:mm:ss a") : "",
                po: element.po ?? "",
              };
              woStatus.get(element.wo_id).reportsLeft--;
              files.push(file);
            }
          } else {
            const time_stamp = moment(element.time_stamp).format(
              "MM/DD/YYYY, h:mm:ss a",
            );
            const file = {
              path: element.path.split("/")[pathIdx],
              wo: element.wo_id,
              customer: element.customer_id,
              checked: false,
              receivedDate: element.received_date,
              time: time_stamp === "Invalid date" ? "-" : time_stamp,
              created_by: element.created_by,
              type: element.belongs,
              reportID: element.report_id,
              qc: element.ml_soft_qc_result,
              sample_info: element.sample_info,
              s3Path: element.path,
              approve_status: element.approve_status,
              approved_by: element.approved_by,
              approved_at: element.approved_at ? moment(element.approved_at).format("MM/DD/YYYY, h:mm:ss a") : "",
              sent_by: element.sent_by,
              sent_at: element.sent_at ? moment(element.sent_at).format("MM/DD/YYYY, h:mm:ss a") : "",
              po: element.po ?? "",
            };
            files.push(file);
          }
        });
        this.setState({
          filesReady: files,
          counter: 0,
          selectAll: false,
          loading: false,
          skeletonLoading: false,
          qcLoading: false,
          woStatus,
          searchValue: input,
          order,
        }, () => console.log("reports per workorder: ", woStatus));
        if (server) this.handleSenderReports(files, null);
      } else if (!response.canceled) {
        this.setState({
          loading: false,
          skeletonLoading: false,
          qcLoading: false,
          filesReady: files,
          counter: 0,
          selectAll: false,
          searchValue: input,
          order,
        });
        if (!response.success) {
          toast.error("Something went wrong");
        }
      }
    });
  };

  fetchUserList = async () => {
    const { createByUserOptions, approvedByUserOptions } = this.state;
    const response = await getUserList();
    if (response.success) {
      const userList = response.results;
      const { createByOptions, approvedByOptions } = userList?.reduce((acc, u) => {
        const label = `${u.first_name} ${u.last_name}`;
        acc.createByOptions.push({ value: u.id, label });
        acc.approvedByOptions.push({ value: u.email, label });
        return acc;
      }, { createByOptions: [], approvedByOptions: [] })

      this.setState({
        createByUserOptions: [...createByUserOptions, ...createByOptions],
        approvedByUserOptions: [...approvedByUserOptions, ...approvedByOptions],
      });
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  handleChangeCheckbox = (file) => {
    const { filesReady: list, woStatus } = this.state;
    let { counter } = this.state;
    list.forEach((report) => {
      if (report.path === file) {
        if (report.checked) {
          counter -= 1;
          woStatus.get(report.wo).reportsLeft++;
        } else {
          counter += 1;
          woStatus.get(report.wo).reportsLeft--;
        }
        report.checked = !report.checked;
      }
    });
    this.setState({
      filesReady: list,
      counter,
      woStatus,
    });
  };

  /**
   * If the report status filter is either Approved or Hold,
   * when a user selects the opposite status for the selected report,
   * we need to remove the selected report from the report list if the
   * api succeeded and uncheck the checkbox
   * @param {*} data
   * @param {*} message
   */
  uncheckAndRemoveItem = (data, message) => {
    const { filesReady, woStatus } = this.state;
    const email = getUser().email;
    let { counter } = this.state;
    if (data.checked) {
      counter += 1;
      woStatus.get(data.wo).reportsLeft--;
      data.checked = false;
    }
    filesReady.splice(data.currPreviewIdx, 1);
    this.setState({
      filesReady,
      counter,
      woStatus,
      previewFile: {
        ...data,
        approve_status: data.approve_type,
        approved_by: email,
        approved_at: moment(new Date()).format("MM/DD/YYYY, h:mm:ss a"),
      },
    });
    toast.success(message);
  };

  removeBadReports = (woObj) => {
    const { filesReady: list, woStatus } = this.state;
    let { counter } = this.state;
    list.forEach((report) => {
      if (report.wo === woObj.wo_id) {
        if (report.checked) {
          counter -= 1;
          woStatus.get(report.wo).reportsLeft++;
          report.checked = !report.checked;
        }
      }
    });

    this.setState({
      filesReady: list,
      counter,
      woStatus,
    });
  }

  togglePreview = (previewData) => {
    const { filesReady } = this.state;
    // Sync the latest sample info from the preview sample table
    const {
      currPreviewIdx, sample_info,
    } = previewData;
    filesReady[currPreviewIdx].sample_info = sample_info;

    this.setState({
      showPreview: false,
      currWoId: "",
      previewFile: "",
      enableEdit: false,
      filesReady,
    });
  };

  handlePreview = async (file, index) => {
    const { tab } = this.props;
    this.setState({ fileLoadingIndex: index });
    const { blob, presignedFailed, aborted } = await this.getPreviewFileFromS3(file.s3Path);
    if (blob === "") {
      if (presignedFailed && !aborted) {
        toast.error("Failed to fetch the presigned URL");
      } else if (!aborted) {
        toast.error("Failed to get the File from AWS S3");
      }
      if (!aborted) {
        this.setState({ fileLoadingIndex: null });
      }
    } else {
      const url = window.URL.createObjectURL(blob);
      const previewObj = {
        ...file,
        url,
        title: file.path.slice(0, -4),
        currPreviewIdx: index,
        samlpe_info: file.sample_info,
      };
      const userDetails = getUser();
      /** Dont't allow the edit result and re-generate report for pesticide report */
      const enableEdit = !/.*P$/.test(file.reportID) && tab === "available" && userDetails.permissionMap.change_test_result_sendreports;
      this.setState({
        previewFile: previewObj,
        showPreview: true,
        currWoId: file.wo,
        currPreviewIdx: index,
        enableEdit,
        fileLoadingIndex: null,
      });
    }
  };

  // public
  getPreviewFileFromS3 = async (s3Path) => {
    const { tab } = this.props;
    /**
     * Even though the backend reponse is /pending/, we only have the available and history folder in s3.
     * So we need to replace /pending/ to /available/
     */
    if (tab === "pending") {
      s3Path = s3Path.replace("/pending/", "/available/");
    } else if (tab === "hold") {
      s3Path = s3Path.replace("/hold/", "/available/");
    }

    const controller = new AbortController();
    this.abortPrevApiCall(controller);
    const response = await getFileFromS3(s3Path, s3AutomationPrivate, false, true, "application/pdf", controller.signal);
    return { ...response };
  };

  handleSelectAll = () => {
    const {
      filesReady: list, selectAll, woStatus,
    } = this.state;
    let { counter } = this.state;
    counter = 0;
    if (!selectAll) {
      list.forEach((report) => {
        if (!report.checked) {
          woStatus.get(report.wo).reportsLeft--;
        }
        report.checked = true;
        counter += 1;
      });
    } else {
      list.forEach((report) => {
        if (report.checked) {
          woStatus.get(report.wo).reportsLeft++;
        }
        report.checked = false;
        counter = 0;
      });
    }
    this.setState({
      selectAll: !selectAll,
      filesReady: list,
      counter,
      woStatus,
    });
  };

  handleClearAll = () => {
    const { filesReady: list, woStatus } = this.state;
    let { counter } = this.state;
    list.forEach((report) => {
      if (report.checked) {
        woStatus.get(report.wo).reportsLeft++;
      }
      report.checked = false;
      counter = 0;
    });
    this.setState({
      filesReady: list, counter, selectAll: false, woStatus,
    });
  };

  handleDownload = async () => {
    const { filesReady, skeletonLoading } = this.state;
    if (skeletonLoading) {
      toast.warning("Please Select a report");
      return;
    }
    const { tab } = this.props;
    const list = filesReady;
    const data = [];
    let downloadedCount = 0;
    // Collect all the S3 paths
    list.forEach((file) => {
      if (file.checked === true) {
        let path = file.s3Path;
        if (tab === "pending") {
          path = file.s3Path.replace("/pending/", "/available/");
        } else if (tab === "hold") {
          path = file.s3Path.replace("/hold/", "/available/");
        }
        data.push({ path, fileName: file.path });
      }
    });
    if (data.length === 0) {
      toast.warning("Please Select a report");
      return;
    }

    // Fetch all the files' presigned URL
    const presignedData = await getPresignedURL({
      action: "get",
      urls: data.map((item) => ({
        Bucket: s3AutomationPrivate.bucket,
        Region: s3AutomationPrivate.region,
        Name: item.path,
      })),
    });
    // Download files based on the presigned URLs
    if (presignedData.success) {
      for (let i = 0; i < data.length; i++) {
        const { path, fileName } = data[i];
        downloadFileFromS3(path, s3AutomationPrivate, fileName, presignedData.result[path]).then((downloadResp) => {
          if (!downloadResp.success) {
            toast.error(`Failed to download ${fileName}`); // Show error when download fails
          }
        });
        if (++downloadedCount >= 10) {
          await pause(1500);
          downloadedCount = 0;
        }
      }
    } else {
      toast.error("Failed to fetch the presigned URL");
    }
  };

  /**
   * Handle "Pending", "Hold", "Available" buttons.
   * @param {String} category "pending", "hold", "available"
   * @returns {void}
   */
  handleMove = async (category) => {
    const { skeletonLoading, counter } = this.state;
    const payload = [];
    const showPopup = this.handleSelectedReportsBlocking();

    if (!showPopup) {
      const sendList = this.getSendList([]);
      sendList.forEach((file) => {
        if (file.checked === true) {
          payload.push(file.reportID);
        }
      });
      if (payload.length < 1 || skeletonLoading) {
        toast.warning("Please Select a report");
        return;
      }
      const tabTitle = `${category[0].toUpperCase()}${category.slice(1)}`;
      this.setState({
        moveCategory: category,
        showConfirmation: true,
        fromRemoveClick: false,
        confirmationTitle: "Confirm Move Report",
        confirmationBodyComponent: () => (
          <div>
            You are about to move
            <b>
              {` ${counter} report${counter > 1 ? "s" : ""}`}
            </b>
            {" to "}
            <Tag className="SendReportConfirmationTag">{tabTitle}</Tag>
            Tab.
          </div>
        ),
      });
    }
  };

  handleSenderReports = async (serverFiles, log) => {
    const { skeletonLoading } = this.state;
    const reportsRenamedWithWO = [];
    const s3UrlsAndIDs = [];
    const sendList = this.getSendList(serverFiles);
    if (sendList.length < 1 || skeletonLoading) {
      toast.warning("Please Select a report");

      this.setState({
        sendingReports: false,
        loading: false,
      });
      return;
    }
    console.log("Send List: ", sendList);
    Promise.all(
      sendList.map(async (file) => {
        const nameWithoutSpace = file.path.split(" ").join("");
        const UrlId = {
          url: nameWithoutSpace, // For the ESV API, we attach the rename URL
          id: file.wo,
          order_id: file.wo,
          companyName: file.customer,
          date: file.receivedDate,
          reportID: file.reportID,
          sample_info: file.sample_info,
          po: file.po,
          originalS3Url: file.s3Path, // For the sendreports/, we attach the original path
        };

        const renamedFile = await this.getFileFromAWS(
          file.path,
          nameWithoutSpace,
          file.s3Path,
        );
        if (renamedFile !== null) {
          s3UrlsAndIDs.push(UrlId);
          reportsRenamedWithWO.push({
            file: renamedFile,
            wo: file.wo,
            companyName: file.customer,
            reportID: file.reportID,
          });
        }
        return Promise.resolve(renamedFile);
      }),
    ).then(() => {
      this.groupByCompanyNamesAndDate(s3UrlsAndIDs);
      this.senderReportsAPIs(reportsRenamedWithWO, log);
    });
  };

  getSendList = (serverFiles) => {
    const { server, tab } = this.props;
    const { filesReady } = this.state;
    const { woStatus } = this.state;
    const list = server ? [] : filesReady;
    const sendList = [];

    list.forEach((report) => {
      if (tab === "history") {
        if (report.checked === true) {
          sendList.push(report);
        }
      } else if (report.checked === true && woStatus.get(report.wo).reportsLeft === 0) {
        sendList.push(report);
      } else if (report.checked === true && woStatus.get(report.wo).reportsLeft > 0) {
        this.removeBadReports(woStatus.get(report.wo));
      }
    });

    if (server) {
      serverFiles.forEach((report) => {
        if (woStatus.get(report.wo).reportsLeft === 0) {
          sendList.push(report);
        } else {
          woStatus.get(report.wo).reportsLeft++;
        }
      });
    }
    return sendList;
  }

  senderReportsAPIs = (reportsRenamedWithWO, log) => {
    this.setState({ loading: true }, () => {
      const { groupedCompanyNamesAndDate, emailSent } = this.state;
      const { tab } = this.props;
      if (!!reportsRenamedWithWO && reportsRenamedWithWO.length > 0) {
        // samples
        this.apiGetSamplesForWO(reportsRenamedWithWO).then((res1) => {
          if (res1 && keys(res1.params).length > 0) {
            // s3
            this.addReportsToAWS(reportsRenamedWithWO, (err2, res2) => {
              if (res2 && res2.code === 200) {
                // esv
                this.apiPostSampleForWO(
                  res1.params,
                  res2.params,
                ).then(() => {
                  // email
                  this.apiPosts3UrlsGrouped(groupedCompanyNamesAndDate).then(
                    () => {
                      this.logSendReports(log);
                      if (tab === "history") {
                        this.setState({
                          loading: false,
                          showEmailFailed: true,
                          groupedCompanyNamesAndDate: [],
                          emailSent: [],
                          sendingReports: false,
                        });
                      } else {
                        // move
                        this.moveFilesToHistory(emailSent).then(() => {
                          this.setState({
                            loading: false,
                            showEmailFailed: true,
                            groupedCompanyNamesAndDate: [],
                            emailSent: [],
                            sendingReports: false,
                          });
                        });
                      }
                    },
                  );
                });
              } else {
                toast.error("Something went wrong (AWS S3)");
                this.setState({
                  loading: false,
                  showEmailFailed: true,
                  groupedCompanyNamesAndDate: [],
                  emailSent: [],
                  sendingReports: false,
                });
              }
            });
          } else if (res1.code === 500) {
            toast.error("Something went wrong (Get Samples).");
            this.setState({
              loading: false,
              groupedCompanyNamesAndDate: [],
              emailSent: [],
              sendingReports: false,
            });
          } else if (keys(res1.params).length === 0) {
            toast.error("No Samples data (Get Samples).");
          }
        });
      } else {
        toast.error("Something went wrong");
        this.setState({
          loading: false,
          showEmailFailed: false,
          groupedCompanyNamesAndDate: [],
          emailSent: [],
          sendingReports: false,
        });
      }
    });
  };

  moveFilesToHistory = async (emailsSent) => {
    const { tab, server } = this.props;
    const { searchValue, historyDate, order } = this.state;
    const category = server ? "available" : tab;
    const input = searchValue;
    const date = category === "history" ? historyDate : "";
    const payload = [];
    console.log("category", category, "\nemailsSent", emailsSent);
    emailsSent.forEach((file) => {
      payload.push({ report_id: file.reportID, wo_id: file.order_id, sample_info: file.sample_info });
    });
    const response = await moveFilesToHistory(payload, category);
    if (response && response.success) {
      if (!server) this.getFilesReady(date, input, order, category);
    } else {
      toast.error("Files failed to Move to History");
    }
  };

  apiPosts3UrlsGrouped = async (groupedCompanyNamesAndDate) => {
    const { emailFailed, emailSent } = this.state;
    // eslint-disable-next-line guard-for-in
    for (const key in groupedCompanyNamesAndDate) {
      const response = await sendS3UrlGrouped(groupedCompanyNamesAndDate[key]);
      if (response.success) {
        // if (response["0"].failed_for.length > 0) {
        //   console.log(
        //     "Failed For (Server Response):",
        //     response["0"].failed_for
        //   );
        //   alert(`Failed for: \n${response["0"].failed_for.join("\n")}`);
        // }
        emailSent.push(...groupedCompanyNamesAndDate[key]);
      } else {
        emailFailed.push(...groupedCompanyNamesAndDate[key]);
      }
    }
    this.setState({
      emailSent,
      emailFailed,
    });
  };

  // create post params
  createPostParams = (reportsData, reportsPath) => {
    const params = [];
    Object.entries(reportsData).forEach(([key, value]) => {
      const path = reportsPath[`${key}`];
      for (let j = 0; j < value.length; j++) {
        const obj = value[j];
        obj.path = path;
        const belongsTo = obj.belongs_to;
        let ctg = "product";
        if (belongsTo === "0-Sponge" || belongsTo === "0-Swab") {
          ctg = "env";
        }
        params.push({ ctg, data: obj });
      }
    });

    return params;
  };

  // public
  getFileFromAWS = (file, nameWithoutSpace, s3Path) => {
    const { tab } = this.props;
    const { fileFailedToGet } = this.state;
    /**
     * Even though the backend reponse is /pending/, we only have the available and history folder in s3.
     * So we need to replace /pending/ to /available/
     */
    if (tab === "pending") {
      s3Path = s3Path.replace("/pending/", "/available/");
    } else if (tab === "hold") {
      s3Path = s3Path.replace("/hold/", "/available/");
    }
    return new Promise((resolve) => {
      getFileFromS3(s3Path, s3AutomationPrivate).then(({ blob }) => {
        if (blob) {
          const renamedFile = new File([blob], nameWithoutSpace, {
            type: "application/pdf",
          });
          return resolve(renamedFile);
        }
        this.setState({
          fileFailedToGet: [...fileFailedToGet, file],
          showFailedToGet: true,
          loading: false,
        });
        return resolve(null);
      });
    });
  };

  // save the uploaded reports to AWS
  addReportsToAWS = (reports, callback) => {
    const reportsPath = {};
    async.each(
      reports,
      (file, eachcallback) => {
        uploadFileToS3({
          file: file.file,
          key: `COAs/${file.file.name}`,
          type: file.file.type,
        }, s3ESVPrivate, true).then(({ success, path }) => {
          if (success && path) {
            reportsPath[file.reportID] = path;
            eachcallback();
          }
        });
      },
      (err) => {
        callback(err, { params: reportsPath, code: 200 });
      },
    );
  };

  // post api call to save sample data with path to DB
  apiPostSampleForWO = async (reportsData, reportsPath) => {
    const params = this.createPostParams(reportsData, reportsPath);
    console.log("Samples Group:", reportsData, "\nESV Payload:", params);
    const failedReports = new Set();
    for (const param of params) {
      const response = await saveData(param);
      if (response && !response.success) {
        failedReports.add(param.data.path);
      }
    }
    return { failedReports };
  };

  // api call to get sample data for uploaded reports using work order number
  apiGetSamplesForWO = async (reportsRenamedWithWO) => {
    const reportsData = {};
    const ctgs = {};
    let code = 200;
    for (const file of reportsRenamedWithWO) {
      const response = await getData(file);
      if (response && response.success) {
        reportsData[file.reportID] = response.samples;
        ctgs[file.reportID] = response.ctg;
      } else {
        code = 500;
      }
    }
    return {
      params: reportsData,
      ctgs,
      code,
    };
  };

  handleSearchSubmit = (e, value, updateSearch) => {
    if (updateSearch) {
      this.setState({
        searchValue: value,
      });
      return;
    }
    if (typeof e.key === "string" && e.key.toLowerCase() === "enter") {
      this.setState({
        searchValue: value,
      });
    }
    const { tab } = this.props;
    const { historyDate } = this.state;
    const category = tab;
    const date = category === "history" ? historyDate : "";
    // const order = this.state.order;
    const input = value;
    if (e.key === "Enter") {
      this.getFilesReady(date, input, "DSC", category);
    }
  };

  handleHistoryDate = (dateRange) => {
    const { tab } = this.props;
    const { searchValue } = this.state;
    const category = tab;
    const input = searchValue;
    this.setState({
      historyDate: dateRange,
      order: "DSC",
    });
    this.getFilesReady(dateRange, input, "DSC", category);
  };

  toggleFailedReportsEmailModal = () => {
    const { showEmailFailed } = this.state;
    this.setState({
      showEmailFailed: !showEmailFailed,
      emailFailed: [],
      loading: false,
    });
  };

  toggleFailedToGetModal = () => {
    const { showFailedToGet } = this.state;
    this.setState({
      showFailedToGet: !showFailedToGet,
      fileFailedToGet: [],
      loading: false,
    });
  };

  handleRemove = async () => {
    const { skeletonLoading, counter } = this.state;
    const showPopup = this.handleSelectedReportsBlocking();
    const payload = [];

    if (!showPopup) {
      const sendList = this.getSendList([]);
      sendList.forEach((file) => {
        if (file.checked === true) {
          payload.push(file.reportID);
        }
      });
      if (payload.length < 1 || skeletonLoading) {
        toast.warning("Please Select a report");
        return;
      }
      this.setState({
        showConfirmation: true,
        fromRemoveClick: true,
        confirmationTitle: "Confirm Remove Report",
        confirmationBodyComponent: () => (
          <div>
            You are about to remove
            <b>
              {` ${counter} report${counter > 1 ? "s" : ""}`}
            </b>
          </div>
        ),
      });
    }
  };

  /**
   * Callback function when users click Confirm for deleting reports or moving repors to pending
   */
  handleRemovePendingConfirm = () => {
    const { fromRemoveClick } = this.state;
    this.setState({ loading: true }, () => {
      if (fromRemoveClick) {
        this.handleRemoveConfirm();
      } else {
        this.handleMoveConfirm();
      }
    });
  }

  /**
   * Make an api call to delete the selected reports
   */
  handleRemoveConfirm = async () => {
    const { tab } = this.props;
    const { historyDate, order, searchValue } = this.state;
    const payload = [];
    const category = tab;
    const date = category === "history" ? historyDate : "";
    const input = searchValue;

    const sendList = this.getSendList([]);
    sendList.forEach((file) => {
      if (file.checked === true) {
        payload.push(file.reportID);
      }
    });
    const response = await deleteFiles(payload);
    if (response && response.success) {
      toast.success("Removed Successfully");
      this.getFilesReady(date, input, order, category);
      this.resetConfirmationPopupStates();
    } else {
      toast.error(response.message);
      this.resetConfirmationPopupStates(true);
    }
  }

  /**
   * Make an api call to move the selected reports to Pending, Hold, or Available.
   */
  handleMoveConfirm = async () => {
    const { tab } = this.props;
    const { searchValue, moveCategory } = this.state;
    const category = tab;
    const date = "";
    const order = "DSC";
    const input = searchValue;
    const reportIdList = [];
    const sendList = this.getSendList([]);
    sendList.forEach((file) => {
      if (file.checked === true) {
        reportIdList.push(file.reportID);
      }
    });
    const response = await moveFiles({ report_id_list: reportIdList, category: tab, new_category: moveCategory });
    const tabTitle = `${moveCategory[0].toUpperCase()}${moveCategory.slice(1)}`;
    if (response && response.success) {
      toast.success(`Successfully moved to ${tabTitle}`);
      this.getFilesReady(date, input, order, category);
      this.resetConfirmationPopupStates();
    } else {
      toast.error(response.message);
      this.resetConfirmationPopupStates(true);
    }
  }

  handleTimeSort = async () => {
    const { tab } = this.props;
    const { searchValue, historyDate } = this.state;
    const category = tab;
    const input = searchValue;
    const date = category === "history" ? historyDate : "";
    let { order } = this.state;
    if (order === "DSC") {
      order = "ASC";
      this.setState({
        order,
        fileNameSort: false,
      });
    } else {
      order = "DSC";
      this.setState({
        order,
        fileNameSort: false,
      });
    }
    this.getFilesReady(date, input, order, category);
  };

  handleTypeSort = async () => {
    const { tab } = this.props;
    const { searchValue, historyDate } = this.state;
    const category = tab;
    const input = searchValue;
    const date = category === "history" ? historyDate : "";
    let { order } = this.state;
    if (order === "DSC") {
      order = "ASC";
      this.setState({
        order,
        fileNameSort: true,
      });
    } else {
      order = "DSC";
      this.setState({
        order,
        fileNameSort: true,
      });
    }
    this.getFilesReady(date, input, order, category);
  };

  handleShowingSendReportsButton = () => {
    const { sendingReports, skeletonLoading, counter } = this.state;
    const { tab } = this.props;

    return (
      <Button
        type="button"
        onClick={() => this.handleSendingReports(tab === "history")}
        className="reportsReadyFooterSendBtn"
        loading={sendingReports}
        disabled={skeletonLoading || sendingReports || counter === 0}
      >
        {`Send (${counter})`}
      </Button>
    );
  }

  resetQCState = () => {
    this.setState({
      selectedReports: {
        qcNotRun: [],
        qcFailed: [],
        qcUnknown: [],
      },
      badWoList: [],
      markCategory: null,
    });
  }

  checkQCReports = () => {
    const { filesReady, badWoList } = this.state;
    const list = filesReady.slice();
    // Used to populate data for display in the modal
    const qcNotRun = [];
    const qcFailed = [];
    const qcUnknown = [];
    const qcPassed = [];
    list.forEach((report) => {
      // Populate selectedReport arrays
      if (report.checked === true) {
        if (report.qc === 0 || report.qc === null) {
          qcNotRun.push(report);
        } else if (report.qc === 2) {
          qcFailed.push(report);
        } else if (report.qc === 3) {
          qcUnknown.push(report);
        } else {
          qcPassed.push(report);
        }
      }
    });

    this.setState({
      selectedReports: {
        qcNotRun,
        qcFailed,
        qcUnknown,
        qcPassed,
      },
      markCategory: null,
    }, () => {
      const showConfirmPopup = qcNotRun.length > 0 || qcFailed.length > 0 || qcUnknown.length > 0 || badWoList.length > 0;
      if (!showConfirmPopup) {
        this.handleSendingReports(true);
      }
    });
  }

  handleSelectedReportsBlocking = () => {
    const { filesReady, badWoList } = this.state;
    const { woStatus } = this.state;
    const list = filesReady;
    const woList = badWoList;

    list.forEach((report) => {
      if (report.checked === true && woStatus.get(report.wo).reportsLeft > 0) {
        if (woList.indexOf(report.wo) === -1) {
          woList.push(report.wo);
        }
      }
    });

    this.setState({
      badWoList: woList,
    });
    return woList.length !== 0;
  }

  /**
   * Check if any Hold/Retesting status report was selected
   */
  hasPendingHoldRetestingReport = () => {
    const { filesReady, actionsList } = this.state;
    const { tab } = this.props;
    const invalidReportStatus = [0, 2, 3]; // Pending, Hold, Retesting
    const invalidReportSelected = filesReady.find((file) => file.checked && invalidReportStatus.includes(file.approve_status));
    if (invalidReportSelected && tab !== "history") {
      const status = actionsList.find((action) => action.value === invalidReportSelected.approve_status);
      const statusText = status ? status.label : "";
      toast.info(`Please remove the '${statusText}' status report (${invalidReportSelected.reportID}) for WO (${invalidReportSelected.wo}) before sending.`);
      return true;
    }
    return false;
  }

  handleSendingReports = (userConfirmation) => {
    const { tab } = this.props;
    if (this.hasPendingHoldRetestingReport()) {
      return;
    }
    this.handleSelectedReportsBlocking();
    if (!userConfirmation) {
      this.checkQCReports();
    } else {
      this.setState({
        sendingReports: true,
        loading: true,
      }, () => {
        const { sendingReports, selectedReports } = this.state;
        if (sendingReports) {
          const userDetails = getUser();
          const log = {
            user: userDetails.email,
            role: userDetails.role,
            version: getAppVersion(),
            app: "MySql",
            tab,
            legacy: true,
            reports: keys(selectedReports).reduce((obj, key) => {
              if (selectedReports[key].length > 0) {
                obj[key] = selectedReports[key].map((report) => report.path);
              }
              return obj;
            }, {}),
          };
          this.resetQCState();
          this.handleSenderReports([], log);
        }
      });
    }
  }

  handleSendingReportsAuto = () => {
    this.setState({
      sendAutoConfirm: true,
      markCategory: null,
      runQcType: null,
      showConfirmation: true,
      fromRemoveClick: false,
      confirmationTitle: "Confirm Send All Approved Reports",
      confirmationBodyComponent: () => (
        <span>You are about to send all approved reports. This will open a new window to send the reports.</span>
      ),
    });
  }

  handleRunQC = async (report_id_list = []) => {
    this.setState({
      sendingReports: false,
      qcLoading: true,
      loading: true,
      selectedReports: {
        qcNotRun: [],
        qcFailed: [],
        qcUnknown: [],
      },
      badWoList: [],
    });
    this.abortPrevApiCall();
    const payload = {
      rerun: false,
    };
    if (report_id_list.length > 0) {
      payload.report_id_list = report_id_list;
    }
    const response = await runQCApiPost(payload);
    if (response.success) {
      this.resetStateAfterRunQC();
    } else {
      this.resetStateAfterRunQC();
      toast.error(response.message);
    }
  }

  handleCurrentMonthClick = () => {
    const { datePickerRef } = this.state;
    if (datePickerRef.current) {
      datePickerRef.current.blur();
    }
    this.handleHistoryDate(getHistoryDates().startDate);
  };

  renderExtraFooter = () => (
    <div className="ant-picker-footer SendReports__HistoryDatePickerFooter">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className="ant-picker-today-btn" onClick={this.handleCurrentMonthClick}>This Month</a>
    </div>
  );

  /**
   * Reset the confirmation popup related states.
   */
  resetConfirmationPopupStates = (error_reset = false) => {
    if (error_reset) {
      this.setState({
        loading: false,
        skeletonLoading: false,
        qcLoading: false,
      });
    } else {
      this.setState({
        showConfirmation: false,
        confirmationTitle: "",
        confirmationBodyComponent: null,
        fromRemoveClick: false,
        moveCategory: "",
        markCategory: null,
        runQcType: null,
        sendAutoConfirm: false,
      });
    }
  }

  logSendReports = (log) => {
    if (!log) return;
    SendLog(log, new Date().toISOString());
  }

  /**
   * Make an api call to update the test's result value, and set the new test's result
   * @param {*} payload
   * @param {*} qcIdx
   * @returns
   */
  updateReusltApi = async (payload) => {
    const resp = await updateTestResult(payload);
    if (resp.success) {
      toast.success(resp.message ?? "Result updated successfully");
    } else {
      toast.error(resp.message ?? "Something went wrong");
    }
    return resp;
  }

  /**
   * Make an api call to generate a report for the current selected workorder
   * @returns
   */
  generateReport = async () => {
    const {
      currWoId,
      currPreviewIdx,
      filesReady,
      searchValue,
      order,
      user,
    } = this.state;
    const { tab } = this.props;
    const received_date = filesReady[currPreviewIdx].receivedDate;
    const date = moment(new Date()).format(DateFormat);
    const list = [{
      wo_id: currWoId,
      is_partial: "True",
    }];

    const resp = await postBatchReports(list, date, null, received_date, true, false, user.id, { action: "Re-generate Report" });
    if (!resp.success) {
      toast.error(resp.message ?? "Something went wrong");
      return resp;
    }
    this.setState({
      showPreview: false,
      currWoId: "",
      currPreviewIdx: -1,
      previewFile: "",
      enableEdit: false,
    }, () => this.getFilesReady("", searchValue ?? "", order, tab));
    toast.success("Report generated successfully.");
    return resp;
  }

  addTableSkeleton = (i) => {
    const { tab } = this.props;
    const { user } = this.state;
    const allColumns = [
      { name: "Checkbox" },
      { name: "WO" },
      { name: "CustomerName" },
      { name: "File" },
      { name: "Created by", permission: "view_sendreports_created_by" },
      { name: "Sent By", showColumnForTab: "history" }, // only include if history
      { name: "QC Status" },
      { name: "Report Status" },
    ]
    const columnKeys = allColumns.reduce((ret, item) => {
      const { permission, name, showColumnForTab } = item;
      const allowForAllTabsAndPermission = !permission && !showColumnForTab;
      if (permission && user.permissionMap[permission]) {
        ret.push(name);
      } else if (showColumnForTab && showColumnForTab === tab) {
        ret.push(name);
      } else if (allowForAllTabsAndPermission) {
        ret.push(name);
      }
      return ret;
    }, []);

    return (
      <tr key={`SendReport-tr-${i}`}>
        {[...Array(columnKeys.length)].map((_, j) => (
          <td key={`SendReport-${i}-${j}`} className="SendReport__Skeleton__General_Td">
            <Skeleton.Input className="SendReport__Skeleton__Input" active />
          </td>
        ))}
      </tr>
    );
  }

  /**
   * Make an api call to update the selected report send status
   * @param {*} data
   * @returns
   */
  updateStatusApi = async (data) => {
    const { wo: workorder_id, reportID: report_id } = data;
    const { email: user_email, id } = getUser();
    const payload = {
      wo_report_ids: [{ workorder_id, report_id }],
      new_report_status: data.approve_type,
      user_email,
      user_id: id,
    };
    const { selectedFilter, previewFile } = this.state;
    const { success, message } = await updateReportsSendStatus(payload);
    if (success) {
      // update the background state
      const { filesReady } = this.state;
      if (selectedFilter === -1) {
        filesReady[data.currPreviewIdx].approve_status = data.approve_type;
        filesReady[data.currPreviewIdx].approved_by = user_email;
        filesReady[data.currPreviewIdx].approved_at = moment(new Date()).format("MM/DD/YYYY, h:mm:ss a");
      } else if (selectedFilter === 0 && previewFile.approve_status !== 0) {
        // If "Pending" is applied, when a user clicks the "Approve" or "Hold" button
        // for the second time, no need to remove an item or add a item to the main list
        toast.success(message);
        this.setState({
          filesReady,
          previewFile: { ...data, approve_status: data.approve_type },
        });
        return { success, message };
      } else if (selectedFilter !== data.approve_type) {
        // if filter is applied and user selected a opposite report status,
        // then remove the item from the current list and its related states
        this.uncheckAndRemoveItem(data, message);
        return { success, message };
      } else {
        // If a user selects a opposite report status and then selete the same status
        // again, then we need to add the item back to the list
        filesReady.splice(data.currPreviewIdx, 0, {
          ...data,
          approve_status: data.approve_type,
          approved_by: user_email,
          approved_at: moment(new Date()).format("MM/DD/YYYY, h:mm:ss a"),
        });
      }
      this.setState({
        filesReady,
        previewFile: { ...data, approve_status: data.approve_type },
      });
      toast.success(message);
    } else {
      toast.error(message);
    }
    return { success, message };
  }

  handleApproveRejectSampleQC = async (sample, comment) => {
    const { id } = getUser();
    const {
      tis_pk,
      user_correction,
    } = sample;
    const payload = {
      tis_pk: String(tis_pk),
      user_correction: String(user_correction),
      user_id: id,
      ml_qc_comments: comment || "",
    };
    const response = await approveRejectSampleQC(payload);
    if (response.success) {
      const { message, result } = response;
      /**
       * There are two cases for success
       * 1. ML Result is not empty for the test, so backend will updates the user correction and return a object of result
       * 2. ML Result is empty for the test, backend will returns a empty result list
       */
      if (typeof result === "object" && result !== null && !Array.isArray(result)) {
        toast.success(message);
      } else {
        toast.info(message);
      }
    } else {
      toast.error(response.message);
    }
    return response;
  }

  filterByTestCategory = (value) => {
    const { searchValue, order, historyDate, testCategoriesOptions } = this.state;
    const { tab } = this.props;
    const category = value || testCategoriesOptions[0].value;
    this.setState({ selectedCategory: category }, () => {
      this.getFilesReady(tab === "history" ? historyDate : "", searchValue, order, tab);
    });
  };

  /**
   * Make an api call to filter reports with the selected status
   * @param {*} selectedFilter
   */
  handleStausChange = (selectedFilter) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    this.setState({ selectedFilter }, () => {
      this.getFilesReady(tab === "history" ? historyDate : "", searchValue, order, tab);
    });
  }

  handleQcChange = (selectedQc) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedQc }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  handleAiQcChange = (selectedAiQc) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedAiQc }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  handleAiSoftQcChange = (selectedMLSoftQc) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedMLSoftQc }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  handleCreatedByChange = (selectedCreatedBy) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedCreatedBy }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  handleApprovedByChange = (selectedApprovedBy) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedApprovedBy }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  handleSentByChange = (selectedSentBy) => {
    const { searchValue, order, historyDate } = this.state;
    const { tab } = this.props;
    const date = tab === "history" ? historyDate : "";
    this.setState({ selectedSentBy }, () => {
      this.getFilesReady(date, searchValue, order, tab);
    });
  }

  showMarkConfirmation = (new_report_status) => {
    const { actionsList, counter, filesReady, selectedReports } = this.state;
    const status = actionsList.find((item) => item.value === new_report_status)?.label;
    if (new_report_status === 1) {
      const qcNotRun = filesReady.filter((file) => file.qc === 0 && file.checked === true).map((file) => file);
      if (qcNotRun.length > 0) {
        this.setState({
          markCategory: new_report_status,
          selectedReports: {
            ...selectedReports,
            qcNotRun,
          },
        });
        return;
      }
    }
    this.setState({
      markCategory: new_report_status,
      runQcType: null,
      sendAutoConfirm: null,
      showConfirmation: true,
      fromRemoveClick: false,
      confirmationTitle: "Confirm Status Change",
      confirmationBodyComponent: () => (
        <div>
          You are about to change the status of
          <b>
            {` ${counter} report${counter > 1 ? "s" : ""}`}
          </b>
          {" to "}
          <Tag className="SendReportConfirmationTag">{status}</Tag>
        </div>
      ),
    });
  }

  batchUpdateReportStatus = (new_report_status) => {
    this.setState({
      loading: true,
      selectedReports: {
        qcNotRun: [],
        qcFailed: [],
        qcUnknown: [],
      },
    }, async () => {
      const { filesReady } = this.state;
      const wo_report_ids = [];

      filesReady.forEach((file) => {
        const { wo: workorder_id, reportID: report_id } = file;
        if (file.checked === true) {
          wo_report_ids.push({ workorder_id, report_id });
        }
      });

      if (wo_report_ids.length < 1) {
        toast.warning("Please Select a report");
        return;
      }
      const { email: user_email, id } = getUser();
      const payload = {
        wo_report_ids,
        new_report_status,
        user_email,
        user_id: id,
      };
      const { success, message } = await updateReportsSendStatus(payload);
      if (success) {
        const { tab } = this.props;
        const { searchValue, historyDate, order } = this.state;
        const input = searchValue;
        const date = tab === "history" ? historyDate : "";
        toast.success(message);
        this.resetConfirmationPopupStates();
        this.getFilesReady(date, input, order, tab);
      } else {
        toast.error(message);
        this.resetConfirmationPopupStates(true);
      }
    });
  };

  // Open the server route in a new tab
  handleSendAuto = () =>{
    const path = `${window.location.origin}${automatedServerRoute}`;
    window.open(path, '_blank');
    this.resetConfirmationPopupStates();
  }

  handleConfirmationOnConfirm = () => {
    const { markCategory, sendAutoConfirm, runQcType } = this.state;
    if (markCategory !== null) {
      this.batchUpdateReportStatus(markCategory);
    } else if (runQcType !== null) {
      this.handleRunQcOption(runQcType);
    } else if (sendAutoConfirm) {
      this.handleSendAuto();
    } else {
      this.handleRemovePendingConfirm();
    }
  }

  handleRunQcOption = async (rerun) => {
    this.setState({ loading: true }, async () => {
      const { filesReady } = this.state;
      const report_id_list = [];

      filesReady.forEach((file) => {
        const { reportID: report_id } = file;
        if (file.checked === true) {
          report_id_list.push({ report_id });
        }
      });

      if (report_id_list.length < 1) {
        toast.warning("Please Select a report");
        return;
      }
      const { success, message } = await runQCApiPost({ rerun, report_id_list });
      if (success) {
        const { tab } = this.props;
        const { searchValue, historyDate, order } = this.state;
        const input = searchValue;
        const date = tab === "history" ? historyDate : "";
        toast.success(message);
        this.resetConfirmationPopupStates();
        this.getFilesReady(date, input, order, tab);
      } else {
        toast.error(message);
        this.resetConfirmationPopupStates(true);
      }
    });
  }

  showQcConfirmation = (rerun) => {
    const { counter } = this.state;
    this.setState({
      runQcType: rerun,
      markCategory: null,
      sendAutoConfirm: null,
      showConfirmation: true,
      fromRemoveClick: false,
      confirmationTitle: `Confirm ${rerun ? "ReRun" : "Run"} QC`,
      confirmationBodyComponent: () => (
        <div>
          You are about to {rerun ? "ReRun" : "Run"} QC for
          <b>
            {` ${counter} report${counter > 1 ? "s" : ""}`}
          </b>
        </div>
      ),
    });
  }

  actionPopup = () => {
    const { user, counter } = this.state;
    if (counter === 0) return null;
    const { tab } = this.props;
    const markOptions = [
      { label: "Mark as Pending", value: 0, icon: <FieldTimeOutlined /> },
      { label: "Mark as Approve", value: 1, icon: <CarryOutOutlined /> },
      { label: "Mark as Hold", value: 2, icon: <PauseOutlined /> },
      { label: "Mark as Retesting", value: 3, icon: <ReloadOutlined /> },
    ];
    const moveOptions = [
      {
        label: "Move to Available", value: "available", icon: <CarryOutOutlined />, tab: "hold",
      },
      {
        label: "Move to Pending Tab", value: "pending", icon: <FieldTimeOutlined />, tab: "available",
      },
      {
        label: "Move to Hold", value: "hold", icon: <PauseOutlined />, tab: "available",
      },
    ];
    const showMoveOptions = moveOptions.length > 0 && ["available", "hold"].includes(tab);
    const qcOptions = [
      // { label: "Run QC", value: false, icon: <PlaySquareOutlined /> },
      { label: "ReRun QC", value: true, icon: <ReloadOutlined /> },
    ]
    return (
      <div className="SendReportActionPopoverContent">
        <div className="popover-field">
          <label>QC</label>
          <div className="field-options">
            {qcOptions.map((option, i) => {
              const { label, value, icon } = option;
              return (
                <Button key={i} className="field-button" type="text" icon={icon} onClick={() => this.showQcConfirmation(value)}>{label}</Button>
              );
            })}
          </div>
        </div>
        {markOptions.length > 0 && tab !== "history" && (
          <div className="popover-field">
            <label>Mark</label>
            <div className="field-options">
              {markOptions.map((option, i) => {
                const { label, value, icon } = option;
                return (
                  <Button key={i} className="field-button" type="text" icon={icon} onClick={() => this.showMarkConfirmation(value)}>{label}</Button>
                );
              })}
            </div>
          </div>
        )}
        {showMoveOptions && tab !== "history" && (
          <>
            <Divider className="divider" />
            <div className="popover-field">
              <label>Move</label>
              <div className="field-options">
                {moveOptions.filter((item) => !item.tab || item.tab === tab).map((option, i) => {
                  const { label, value, icon } = option;
                  return (
                    <Button key={i} className="field-button" type="text" icon={icon} onClick={() => this.handleMove(value)}>{label}</Button>
                  );
                })}
              </div>
            </div>
          </>
        )}
        {user?.permissionMap.download_sendreports && (
          <>
            <Divider className="divider" />
            <div className="popover-field">
              <div className="field-options">
                <Button className="field-button" type="text" icon={<DownloadOutlined />} onClick={() => this.handleDownload()}>Download</Button>
              </div>
            </div>
          </>
        )}
        {tab === "available" && (
          <>
            <Divider className="divider" />
            <div className="popover-field">
              <div className="field-options">
                <Button className="field-button" type="text" icon={<DeleteOutlined />} onClick={() => this.handleRemove()}><span className="remove">Remove</span></Button>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }

  resetStateAfterRunQC() {
    const { tab } = this.props;
    const { searchValue, order } = this.state;
    const category = tab;
    this.resetQCState();
    this.getFilesReady("", searchValue, order, category);
  }

  groupByCompanyNamesAndDate(s3UrlsAndIDs) {
    // sort by company names
    let sortedS3UrlsAndIDsByCompanyName = s3UrlsAndIDs.sort((a, b) => {
      const companyNameOne = a.companyName.toUpperCase();
      const companyNameTwo = b.companyName.toUpperCase();

      if (companyNameOne < companyNameTwo) {
        return -1;
      }
      return 1;
    });

    // sort by po
    sortedS3UrlsAndIDsByCompanyName = s3UrlsAndIDs.sort((a, b) => {
      const poOne = a.po.toUpperCase();
      const poTwo = b.po.toUpperCase();

      if (poOne < poTwo) {
        return -1;
      }
      return 1;
    });

    // sort by received date
    sortedS3UrlsAndIDsByCompanyName = sortedS3UrlsAndIDsByCompanyName.sort((a, b) => {
      const dateOne = a.date;
      const dateTwo = b.date;

      if (dateOne < dateTwo) {
        return -1;
      }
      return 1;
    });

    const groups = {};
    let counter = 0;
    // PO # can be different in each report, which requires different email to be sent (Removed "Beech-Nut Nutrition Company|Beech" hardcoding)
    sortedS3UrlsAndIDsByCompanyName.forEach((item, index) => {
      let group = [item.companyName, item.po, item.date, counter];
      if (groups[group] !== undefined && groups[group].length > 4) { // same group can have up to 5 reports
        counter++;
        group = [item.companyName, item.po, item.date, counter];
      }
      groups[group] = groups[group] || [];
      groups[group].push({
        s3_url: item.originalS3Url,
        order_id: item.id,
        reportID: item.reportID,
        sample_info: item.sample_info,
      });
      if (index !== sortedS3UrlsAndIDsByCompanyName.length - 1) {
        if ((sortedS3UrlsAndIDsByCompanyName[index].companyName !== sortedS3UrlsAndIDsByCompanyName[index + 1].companyName) || (sortedS3UrlsAndIDsByCompanyName[index].date !== sortedS3UrlsAndIDsByCompanyName[index + 1].date)) {
          counter = 0;
        }
      }
    });

    this.setState({ groupedCompanyNamesAndDate: { ...groups } }, () => {
      const { groupedCompanyNamesAndDate } = this.state;
      console.log("EmailGroups:", groupedCompanyNamesAndDate);
    });
  }

  getConfirmationOkText = () => {
    const { sendAutoConfirm, fromRemoveClick } = this.state;
    if (sendAutoConfirm) {
      return "Send";
    } else if (fromRemoveClick) {
      return "Remove";
    }
    return "Confirm";
  }

  render() {
    const {
      filesReady,
      selectAll,
      loading,
      skeletonLoading,
      qcLoading,
      historyDate,
      emailFailed,
      showEmailFailed,
      fileFailedToGet,
      showFailedToGet,
      order,
      fileNameSort,
      counter,
      showPreview,
      previewFile,
      selectedReports,
      badWoList,
      datePickerRef,
      showConfirmation,
      confirmationBodyComponent,
      currWoId,
      enableEdit,
      actionsList,
      woStatus,
      user,
      testCategories,
      confirmationTitle,
      createByUserOptions,
      approvedByUserOptions,
      fileLoadingIndex,
      selectedCategory,
      testCategoriesOptions,
      markCategory,
    } = this.state;

    const { tab, server } = this.props;
    const { qcFailed, qcNotRun, qcUnknown } = selectedReports;
    const sendBtnAccess = (tab === "history" || (user.permissionMap && user.permissionMap.send_sendreports)) && tab !== "hold";
    const sendAutoBtnAccess = user.permissionMap && user.permissionMap.sendauto_sendreports && tab === "available";
    const showActionPopover = ["available", "pending", "hold"].some((curTab) => curTab === tab);

    return (
      <>
        {!server && (
          <>
            {sendAutoBtnAccess && (
              <Button
              type="button"
              className="reportsReadyFooterSendBtn autosend"
              onClick={this.handleSendingReportsAuto}
            >
              Autosend
            </Button>)
            }
            <div className="sendReportsHeaderOriginal" ref={this.headerRef}>
              <div className="sendReportsInputs">
                {tab !== "pending" && tab !== "hold" && (
                  <SearchSendReports
                    handleSearchSubmit={this.handleSearchSubmit}
                    getFilesReady={this.getFilesReady}
                    date={historyDate}
                    category={tab}
                  />
                )}

                <div className="SendReports__DropdownContainer">
                  <label>Test Category</label>
                  <Select
                    allowClear
                    showSearch
                    className="SendReportsAuto__TestCategorySelect"
                    options={testCategoriesOptions}
                    defaultValue={testCategoriesOptions[0]?.value}
                    value={selectedCategory}
                    onSelect={this.filterByTestCategory}
                    onClear={() => this.filterByTestCategory("")}
                    filterOption={(optionValue, option) => option.label?.toLowerCase().startsWith(optionValue?.toLowerCase())}
                    listHeight={400}
                  />
                </div>

                <div className="SendReports__DropdownContainer">
                  <label>Report Status</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    defaultValue="All"
                    options={actionsList}
                    onSelect={(action) => this.handleStausChange(action)}
                  />
                </div>
                {/* <div className="SendReports__DropdownContainer">
                  <label>QC Status</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    defaultValue="All"
                    options={SOFTWARE_QC_OPTIONS}
                    onSelect={(action) => this.handleQcChange(action)}
                  />
                </div>
                <div className="SendReports__DropdownContainer">
                  <label>AI QC Status</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    defaultValue="All"
                    options={AI_QC_OPTIONS}
                    onSelect={(action) => this.handleAiQcChange(action)}
                  />
                </div> */}
                <div className="SendReports__DropdownContainer">
                  <label>QC Status</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    defaultValue="All"
                    options={ML_SOFTWARE_QC_OPTIONS}
                    onSelect={(action) => this.handleAiSoftQcChange(action)}
                  />
                </div>

                {user.permissionMap.view_sendreports_created_by && (<div className="SendReports__DropdownContainer">
                  <label>Created By</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    showSearch
                    options={createByUserOptions}
                    onSelect={(action) => this.handleCreatedByChange(action)}
                    value={this.state.selectedCreatedBy}
                    defaultValue={createByUserOptions[0]?.value}
                    listHeight={200}
                    allowClear
                    onClear={() => this.handleCreatedByChange("")}
                    filterOption={(inputValue, option) => option.label?.toLowerCase().includes(inputValue?.toLowerCase())}
                  />
                </div>)}

                {user.permissionMap.view_sendreports_approved_by && (<div className="SendReports__DropdownContainer">
                  <label>Approved By</label>
                  <Select
                    className="SendReports__ActionSelect"
                    popupClassName="SendReports__ActionSelect__Menu"
                    showSearch
                    options={approvedByUserOptions}
                    value={this.state.selectedApprovedBy}
                    defaultValue={approvedByUserOptions[0]?.value}
                    onSelect={(action) => this.handleApprovedByChange(action)}
                    listHeight={200}
                    allowClear
                    onClear={() => this.handleApprovedByChange("")}
                    filterOption={(inputValue, option) => option.label?.toLowerCase().includes(inputValue?.toLowerCase())}
                  />
                </div>)}

                {tab === "history" && (
                  <div className="SendReports__DropdownContainer">
                    <label>Sent By</label>
                    <Select
                      className="SendReports__ActionSelect"
                      popupClassName="SendReports__ActionSelect__Menu"
                      showSearch
                      options={createByUserOptions}
                      value={this.state.selectedSentBy}
                      defaultValue={createByUserOptions[0]?.value}
                      onSelect={(action) => this.handleSentByChange(action)}
                      listHeight={200}
                      allowClear
                      onClear={() => this.handleSentByChange("")}
                      filterOption={(inputValue, option) => option.label?.toLowerCase().includes(inputValue?.toLowerCase())}
                    />
                  </div>
                )}

                {tab === "history" && user.permissionMap.view_sendreports_history_date && (
                  <DatePicker
                    showNow={false}
                    allowClear={false}
                    value={historyDate}
                    defaultValue={historyDate}
                    className="reportsHistoryDate"
                    picker="month"
                    format="MMMM YYYY"
                    disabledDate={(current) => current.isAfter(dayjs())}
                    onChange={(e) => this.handleHistoryDate(e)}
                    renderExtraFooter={this.renderExtraFooter}
                    ref={datePickerRef}
                  />
                )}
                {sendBtnAccess && (
                  this.handleShowingSendReportsButton()
                )}
                {tab === "available" && (
                  <Button
                    type="button"
                    onClick={() => this.handleRunQC()}
                    className="reportsReadyFooterDownloadBtn"
                    loading={qcLoading}
                    disabled={skeletonLoading}
                  >
                    QC
                  </Button>
                )}
              </div>
              {user.permissionMap.download_sendreports && !showActionPopover && (
                <div className="reportsReadyFooter">
                  {user.permissionMap.download_sendreports && (
                    <Button
                      type="button"
                      onClick={() => this.handleDownload()}
                      className="reportsReadyFooterDownloadBtn"
                      disabled={skeletonLoading || counter === 0}
                    >
                      {`Download (${counter})`}
                    </Button>
                  )}
                </div>
              )}
              {showActionPopover && (
                <div className="SendReportActionContainer">
                  <span className="counter-text">{`${counter} selected`}</span>
                  <Popover
                    placement="bottom"
                    overlayClassName="SendReportActionPopoverOriginal"
                    arrow={false}
                    content={this.actionPopup()}
                  >
                    <Button icon={<MoreOutlined />} className="actionButton" iconPosition="end" disabled={skeletonLoading || counter === 0}>Actions</Button>
                  </Popover>
                </div>
              )}
            </div>
            <Table bordered={!skeletonLoading} hover={!skeletonLoading} className={`table ${isMobile || isSafari ? " SafariTableDisplay" : ""}`}>
              <thead>
                <tr className="sendReportsTableHeadingOriginal">
                  <td className="sendReportsTableSelectCol">
                    <div className="sendReportsCounter">
                      <input
                        onChange={() => this.handleSelectAll()}
                        type="checkbox"
                        name=""
                        id=""
                        checked={selectAll}
                      />
                      {counter}
                      <i
                        onClick={() => this.handleClearAll()}
                        className="fa fa-times sendReportsCounterIcon"
                      />
                    </div>
                  </td>
                  <td>Work Order</td>
                  <td>Customer Name</td>
                  <td
                    className="sendReportsTypeSort"
                    onClick={() => tab !== "pending" && tab !== "hold" && this.handleTypeSort()}
                  >
                    File
                    <i
                      className={
                        fileNameSort
                          ? "fa fa-file sendReportsSortIcon"
                          : "fa fa-file sendReportsSortIcon sendReportsSortIconOpacity"
                      }
                      aria-hidden="true"
                    />
                  </td>
                  <td>QC Status</td>
                  <td>Report Status</td>
                  {user.permissionMap.view_sendreports_created_by && (
                    <td
                      onClick={() => tab !== "pending" && tab !== "hold" && this.handleTimeSort()}
                      className="sendReportsTimeSort"
                    >
                      Created By
                      <i
                        className={
                          order === "DSC"
                            ? `fa fa-sort-desc sendReportsSortIcon ${fileNameSort && "sendReportsSortIconOpacity"
                            }`
                            : `fa fa-sort-asc sendReportsSortIcon ${fileNameSort && "sendReportsSortIconOpacity"
                            }`
                        }
                        aria-hidden="true"
                      />
                    </td>)}
                  {tab === "history" && <td>Sent By</td>}
                </tr>
              </thead>
              <tbody className="sendReportsTbody">
                {!skeletonLoading && filesReady.map((file, index) => {
                  return (
                    <tr
                      // style={{ backgroundColor: qcStatusStyles.backgroundColor }}
                      onClick={() => this.handleChangeCheckbox(file.path)}
                      key={index}
                    >
                      <td className="sendReportsCheckboxTD">
                        <input
                          onChange={() => { }}
                          // onChange={() => this.handleChangeCheckbox(file.path)}
                          type="checkbox"
                          name=""
                          id=""
                          checked={file.checked}
                        />
                      </td>
                      <td>{file.wo}</td>
                      <td>{file.customer}</td>
                      <td
                        className="sendReportsFilePath"
                        onClick={() => this.handlePreview(file, index)}
                      >
                        <div className="SendReportAuto__FileName">
                          <p>{file.path}</p>
                          {fileLoadingIndex === index && <LoadingOutlined />}
                        </div>
                      </td>
                      <td>
                        <StatusTag type="QC" result={file.qc} />
                      </td>
                      <td>
                        <div className="SendReportAuto__ReportStatus">
                          <Tooltip
                            placement="top"
                            title={file.approved_by && user.permissionMap.view_sendreports_approved_by ? (
                              <div>
                                <span>{file.approved_by}</span>
                                <br />
                                <span className="SendReportTableTime">{file.approved_at}</span>
                              </div>
                            ) : ""
                            }
                          >
                            <span><StatusTag result={file.approve_status} type="REPORT" /></span>
                          </Tooltip>
                        </div>
                      </td>
                      {user.permissionMap.view_sendreports_created_by && (<td>
                        <Tooltip placement="top" title={file.time}>
                          <span>{file.created_by}</span>
                        </Tooltip>
                      </td>)}
                      {tab === "history" &&
                        <td>
                          <Tooltip placement="top" title={file.sent_at}>
                            <span>{file.sent_by}</span>
                          </Tooltip>
                        </td>}

                    </tr>
                  );
                })}
                {skeletonLoading
                  && [...Array(8)].map((_, index) => this.addTableSkeleton(index + 1))}
              </tbody>
            </Table>
          </>
        )}
        {server && <UnderMaintenance />}
        {loading && !showConfirmation && (
          <div className="reportsReadyLoading">
            <img src={Loading} alt="" />
          </div>
        )}
        {showEmailFailed && (
          <FailedReportsEmailModal
            emailFailed={emailFailed}
            toggleFailedReportsEmailModal={this.toggleFailedReportsEmailModal}
          />
        )}
        {showFailedToGet && (
          <FailedToGetFileModal
            fileFailedToGet={fileFailedToGet}
            toggleFailedToGetModal={this.toggleFailedToGetModal}
          />
        )}
        {showPreview && (
          <SendReportsPreview
            previewFile={previewFile}
            togglePreview={this.togglePreview}
            updateResultApi={(payload, qcIdx) => this.updateReusltApi(payload, qcIdx)}
            generateReport={() => this.generateReport()}
            updateStatusApi={this.updateStatusApi}
            handleApproveRejectSampleQC={this.handleApproveRejectSampleQC}
            currWoId={currWoId}
            enableEdit={enableEdit}
            tab={tab}
            woStatus={woStatus}
            testCategories={testCategories}
          />
        )}
        {((qcFailed.length > 0 || qcNotRun.length > 0 || qcUnknown.length > 0 || badWoList.length > 0) && tab !== "history") && (
          <SendReportsConfirmModal
            selectedReports={selectedReports}
            badWoList={badWoList}
            sendReports={this.handleSendingReports}
            runQC={this.handleRunQC}
            cancelModal={this.resetQCState}
            markCategory={markCategory}
            batchUpdateReportStatus={this.batchUpdateReportStatus}
          />
        )}
        <ConfirmationModal
          open={showConfirmation}
          title={confirmationTitle}
          bodyComponent={confirmationBodyComponent}
          okText={this.getConfirmationOkText()}
          cancelText="Cancel"
          onOk={this.handleConfirmationOnConfirm}
          onCancel={() => this.resetConfirmationPopupStates()}
          loading={loading}
        />
      </>
    );
  }
}
